import { Component, OnDestroy, OnInit, signal } from '@angular/core';
import { Subscription } from 'rxjs';
import { AjaxCallService, CurrentUserService, LoggingInterceptor, NeoPermission, NeoPermissionGroup } from '../core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-page-selector',
  standalone: false,
  styles: ``,
  templateUrl: './page-selector.component.html',
})
export class PageSelectorComponent implements OnInit, OnDestroy {
  private userSubscription: Subscription;

  noAccess = signal(false);

  constructor(private currentUserService: CurrentUserService,
    private ajax: AjaxCallService,
    private router: Router
  ) {
  }

  logout(): void {
    this.ajax.MakeCall('/Account/Logout').then(() => {
      this.router.navigate(['/login']);
    }, () => { });
  }

  ngOnInit(): void {
    this.userSubscription = this.currentUserService.get().subscribe({
      next: (x) => {
        if (x) {
          if (!x.userId) {
            this.router.navigate(['/login']);
            LoggingInterceptor.clear();
          } else if (this.currentUserService.check(NeoPermission.View, NeoPermissionGroup.Users)) {
            this.router.navigate(['/admin', 'users']);
          } else if (this.currentUserService.check(NeoPermission.View, NeoPermissionGroup.Categories)) {
            this.router.navigate(['/admin', 'categories']);
          } else if (this.currentUserService.check(NeoPermission.View, NeoPermissionGroup.Models)) {
            this.router.navigate(['/admin', 'models']);
          } else {
            this.noAccess.set(true);
          }
        }
      },
      error: (x) => {
        this.router.navigate(['/login']);
      }
    });
  }

  ngOnDestroy(): void {
    this.userSubscription.unsubscribe();
  }
}
